var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoiseSuppressionOn = function SvgNoiseSuppressionOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 2.5a.833.833 0 0 0-.833.833v13.334a.833.833 0 0 0 1.666 0V3.333A.833.833 0 0 0 10 2.5M6.667 5a.833.833 0 0 0-.834.833v8.334a.833.833 0 0 0 1.667 0V5.833A.833.833 0 0 0 6.667 5M2.5 8.333a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0zm10 0a.833.833 0 0 1 1.667 0v3.334a.833.833 0 0 1-1.667 0zm3.333-2.5a.833.833 0 0 1 1.667 0v8.334a.833.833 0 0 1-1.667 0z",
    clipRule: "evenodd"
  })));
};
export default SvgNoiseSuppressionOn;